import {
  S3Client,
  ListObjectsV2Command,
  DeleteObjectCommand,
  GetObjectCommand,
} from '@aws-sdk/client-s3';

import { Upload } from '@aws-sdk/lib-storage';
import { XhrHttpHandler } from '@aws-sdk/xhr-http-handler';

// local aws
import getAWSConfig from '@/aws/aws-sdk-config';

const s3Client = new S3Client(getAWSConfig());
const s3ClientUpload = new S3Client(getAWSConfig({ requestHandler: new XhrHttpHandler({}) }));

async function getS3Object(bucketName, key) {
  // Replace the values below with your setup information
  const command = new GetObjectCommand({
    Bucket: bucketName,
    Key: key,
  });
  const resp = await s3Client.send(command);


  return resp;
}

async function getS3Objects(bucketName, Prefix) {
  // Replace the values below with your setup information
  const command = new ListObjectsV2Command({
    Bucket: bucketName,
    Prefix,
  });
  const response = await s3Client.send(command);

  const files = response.Contents;

  return files;
}

async function uploadS3Object(file, key, bucketName, progressCallback) {
  // Replace the values below with your setup information
  const fileStream = await file.arrayBuffer();
  const params = {
    Bucket: bucketName,
    Key: key,
    ContentType: file.type,
    Body: new Uint8Array(fileStream),
  };

  // Read more:
  // https://github.com/aws/aws-sdk-js-v3/tree/main/packages/xhr-http-handler
  // https://github.com/aws/aws-sdk-js-v3/blob/main/lib/lib-storage/README.md
  const upload = new Upload({
    client: s3ClientUpload,
    params,
  });

  /**
     * the progressCallback function is called with the following object:
     * {
     *  loaded: number, // number of bytes uploaded
     *  total: number, // total number of bytes to upload
     *  part: number, // current part number being uploaded
     *  Key: string, // the object key
     *  Bucket: string, // the bucket name
     * }
     */
  if (progressCallback) { upload.on('httpUploadProgress', progressCallback); }

  const result = await upload.done();

  return result;
}


/**
 * @async
 *
 * https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#deleteObject-property
 *
 * Deletes an object from an S3 bucket.
 * @param {string} key - The key of the object to delete.
 * @param {string} bucketName - The name of the S3 bucket.
 *
 * @returns {Promise<Object>}
*/
async function deleteS3Object(key, bucketName) {
  const params = {
    Bucket: bucketName,
    Key: key,
  };

  const result = await s3Client.send(new DeleteObjectCommand(params));

  return result;
}

export {
  getS3Object, getS3Objects, uploadS3Object, deleteS3Object,
};
